import React, { useEffect, useState } from "react"
import ReactStars from "react-rating-stars-component"
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react"

// Import Swiper styles
import "swiper/css"
import "swiper/css/free-mode"
import "swiper/css/pagination"
import "../../App.css"
// Icons
import { FaStar } from "react-icons/fa"
// Import required modules
import { Autoplay, FreeMode, Pagination } from "swiper/modules"

// Get apiFunction and the endpoint
import { apiconnector } from "../../services/apiconnector"
import { ratingsEndpoints } from "../../services/apis"
import { useDispatch, useSelector } from "react-redux"
import { setLoading } from "../../slices/authSlice"

function ReviewSlider() {
  const [reviews, setReviews] = useState([])
  const {loading} = useSelector((state)=>state.auth)
  const dispatch = useDispatch()
  const truncateWords = 15

  useEffect(() => {
    ;(async () => {
      dispatch(setLoading(true))
      const { data } = await apiconnector(
        "GET",
        ratingsEndpoints.REVIEWS_DETAILS_API
      )
      if (data?.success) {
        setReviews(data?.data)
        dispatch(setLoading(false))
      }
    })()
  }, [dispatch])

  // console.log(reviews)

  return (
    <div className="text-white">
      <div className="my-[50px] h-[184px] max-w-maxContentTab lg:max-w-maxContent ">
        {
          loading ?
            <div className="grid min-h-[120px] place-items-center">
                 <div className="spinner"></div>
            </div>
            :
      <Swiper
          spaceBetween={25}
          loop={true}
          freeMode={true}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          slidesPerView={1} // Default for mobile
          breakpoints={{
            640: { slidesPerView: 1 }, // Small screens (sm)
            768: { slidesPerView: 2 }, // Medium screens (md)
            1024: { slidesPerView: 4 }, // Large screens (lg)
          }}
          modules={[FreeMode, Pagination, Autoplay]}
          className="w-full"
      >
          {reviews?.map((review, i) => {
            return (
              <SwiperSlide key={i}>
                <div className="flex flex-col gap-3 bg-richblack-800 p-3 text-[14px] text-richblack-25">
                  <div className="flex md:flex-row flex-col items-center gap-4">
                    <img
                      src={
                        review?.user?.image
                          ? review?.user?.image
                          : `https://api.dicebear.com/5.x/initials/svg?seed=${review?.user?.firstName} ${review?.user?.lastName}`
                      }
                      alt=""
                      className="h-9 w-9 rounded-full object-cover"
                    />
                    <div className="flex flex-col">
                      <h1 className="font-semibold text-richblack-5">{`${review?.user?.firstName} ${review?.user?.lastName}`}</h1>
                      <h2 className="text-[12px] font-medium text-richblack-500">
                        {review?.course?.courseName}
                      </h2>
                    </div>
                  </div>
                  <p className="font-medium text-richblack-25">
                    {review?.review.split(" ").length > truncateWords
                      ? `${review?.review
                          .split(" ")
                          .slice(0, truncateWords)
                          .join(" ")} ...`
                      : `${review?.review}`}
                  </p>
                  <div className="flex items-center gap-2 ">
                    <h3 className="font-semibold text-yellow-100">
                      {review.rating.toFixed(1)}
                    </h3>
                    <ReactStars
                      count={5}
                      value={review.rating}
                      size={20}
                      edit={false}
                      activeColor="#ffd700"
                      emptyIcon={<FaStar />}
                      fullIcon={<FaStar />}
                    />
                  </div>
                </div>
              </SwiperSlide>
            )
          })}
          {/* <SwiperSlide>Slide 1</SwiperSlide> */}
        </Swiper>
}
      </div>
    </div>
  )
}

export default ReviewSlider